import { CommonHelper } from '../commonHelper';
import { useRef } from 'react';
import NoMediafiles from '../../assets/no-media-available.svg';
import { Box, Typography } from '@mui/material';
import { Description as DescriptionIcon } from '@mui/icons-material';

const CarouselComponent = ({ media_urls,mediaType }) => {
  let media = media_urls.split(',')[0];
  let fileType = CommonHelper.GetFileTypeFromUrl(media);
  if (mediaType === "DOCUMENT"){
    fileType = "pdf"
  }
  const videoRef = useRef(null);
  const imgRef = useRef(null);
  if (media === "_thumbnail.jpg"){
    media =NoMediafiles
  }
  const handleVideoClick = () => {
    const videoElement = videoRef.current;
    if (videoElement.requestFullscreen) {
      videoElement.requestFullscreen();
    } else if (videoElement.mozRequestFullScreen) {
      videoElement.mozRequestFullScreen();
    } else if (videoElement.webkitRequestFullscreen) {
      videoElement.webkitRequestFullscreen();
    } else if (videoElement.msRequestFullscreen) {
      videoElement.msRequestFullscreen();
    }
  };
  const handleImageClick = () => {
    const imgElement = imgRef.current;
    if (imgElement.requestFullscreen) {
      imgElement.requestFullscreen();
    } else if (imgElement.mozRequestFullScreen) {
      imgElement.mozRequestFullScreen();
    } else if (imgElement.webkitRequestFullscreen) {
      imgElement.webkitRequestFullscreen();
    } else if (imgElement.msRequestFullscreen) {
      imgElement.msRequestFullscreen();
    }
  };
  return (
    // media_urls.map(media => {
    //     let fileType = CommonHelper.GetFileTypeFromUrl(media);
    //     return fileType === "mp4" ? <>
    //         <video width={50} height={50} src={media} ref={videoRef}
    //             onClick={handleVideoClick} style={{ cursor: 'pointer', borderRadius: '5px' }} />
    //     </> :
    //         <img width={50} height={50} src={media} style={{ margin: '0px 5px', cursor: 'pointer', borderRadius: '2px' }} ref={imgRef}
    //             onClick={handleImageClick} />
    // })

    ['pdf', 'doc', 'docx', 'ppt', 'pptx'].includes(fileType) ? (
      <Box
        sx={{
          width: '100%',
          height: '100%',
          minHeight: 48,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          gap: 0.25,
          bgcolor: 'background.default',
          border: '1px solid',
          borderColor: 'divider',
          borderRadius: '5px',
        }}
      >
        <DescriptionIcon sx={{ width: 24, height: 24, color: 'primary.main' }} />
        <Typography variant="caption" sx={{ fontWeight: 700, textTransform: 'uppercase', lineHeight: 1 }}>
          {fileType}
        </Typography>
      </Box>
    ) : fileType === 'mp4' ? (
      <>
        <video
          width={'100%'}
          height={'100%'}
          src={media}
          ref={videoRef}
          //onClick={handleVideoClick}
          style={{ cursor: 'pointer', borderRadius: '5px' }}
        />
      </>
    ) : (
      <img
        width={'100%'}
        height={'100%'}
        src={media}
        alt="media preview"
        style={{ cursor: 'pointer', borderRadius: '2px', objectFit: media === NoMediafiles ? 'contain' : 'cover' }}
        ref={imgRef}
      // onClick={handleImageClick}
      />
    )
  );
};
export default CarouselComponent;
